import { read_cookie, bake_cookie } from 'sfcookies';
import { SIGNED_IN,SIGNED_OUT } from "../constants";
import firebase from 'firebase';

let user=read_cookie('user');

export default (state=user,action) => {
    switch (action.type) {
    case SIGNED_IN:
        bake_cookie('user',action.user);
        return action.user;
    case SIGNED_OUT:
        user = null;
        bake_cookie('user',user);
        firebase.auth().signOut();
        return user;
    default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/userReducer.js